/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeleteS3ProfilePhotoAdminRequest} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/delete_s3_profile_photo_admin.pb'
import {DeleteS3ProfilePhotoAdminResponse} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/delete_s3_profile_photo_admin.pb'


export const deleteS3ProfilePhotoAdmin = (request: DeleteS3ProfilePhotoAdminRequest, options?: CashRequestOptions) => post<DeleteS3ProfilePhotoAdminRequest, DeleteS3ProfilePhotoAdminResponse>("/2.0/cash/delete-s3-profile-photo-admin", request, {...options, rejectOnError: true })